import { isSessionGenerating } from '@/entities/session';

import type { SessionListItem } from '../model/session.types';

export function isSessionLocked(session: SessionListItem): boolean {
    const note = session.currentNote;
    const hasReviewAction = session.actions.includes('REVIEW_NOTE');

    if (!hasReviewAction) return false;

    return !note || isSessionGenerating(session);
}
